'use client';

import { useCallback } from 'react';
import { useRouter } from 'next/navigation';
import { LOGIN_VARIANT } from '@/constants';
import { useLoginContext } from '@/context/LoginContext';
import { useOverlayContext } from '@/context/OverlayContext';

export const useLogin = () => {
	const { redirectTo, rgisCookie, setRedirectTo } = useLoginContext();
	const { openVariant } = useOverlayContext();
	const isLoggedIn = Boolean(rgisCookie);
	const { push } = useRouter();

	const openLoginDrawer = useCallback(
		(redirectToParam?: string) => {
			if (isLoggedIn && redirectToParam) {
				push(redirectToParam);
				return;
			}
			if (redirectToParam) {
				setRedirectTo(redirectToParam);
			}
			if (!isLoggedIn) {
				openVariant(LOGIN_VARIANT);
			}
		},
		[isLoggedIn, openVariant, push, setRedirectTo],
	);

	return { openLoginDrawer, redirectTo };
};
